/* eslint react/no-danger: 0 */
import React from 'react';
import PropTypes from 'prop-types';

/*
  Google uses structured data that it finds on the web to understand the content of the page,
  as well as to gather information about the web and the world in general.
   Example script:
   <script type="application/ld+json">
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      "url": "http://www.example.com",
      "name": "Unlimited Ball Bearings Corp.",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1-401-555-1212",
        "contactType": "Customer service"
      }
    }
    </script>

    or

    <script type="application/ld+json">
    {
      "@context":"http://schema.org",
      "@type":"Organization",
      "url":"http://localhost.paypal.com:8081/us/smarthelp/contact-us",
      "telephone":"1-866-528-3733",
      "department":"credit card support"
    }
    </script>

    Ref link: https://developers.google.com/search/docs/guides/intro-structured-data
    Google Structured Data Testing Tool:  https://search.google.com/structured-data/testing-tool/
 */

function getParsedGSD(data) {
  try {
    return JSON.stringify(data);
  } catch (e) {
    return '';
  }
}

const GoogleStructuredData = function (props) {
  const { type, data } = props;
  const structuredData = {
    '@context': 'http://schema.org',
    '@type': type,
  };
  Object.assign(structuredData, data);
  return <script type="application/ld+json">{getParsedGSD(structuredData)}</script>;
};

GoogleStructuredData.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

// GoogleStructuredData Props default values.
GoogleStructuredData.defaultProps = {
  data: {},
};
export default GoogleStructuredData;
